import React from 'react'
import BlockingTable from './BlockingTable'
import { useSelector } from 'react-redux'
import RoomBlockingList from '../../../Hotels/Components/RoomBlocking/RoomBlockingList'

const BlockingList = () => {
  const { user, userType } = useSelector((state) => state.auth);
  const adminUser = user?.user || {};
  const adminLevelId = Number(adminUser.LevelId ?? adminUser.LevelID ?? adminUser.levelId ?? 0);
  const hasHotelScope = adminUser.PropertyID !== null && adminUser.PropertyID !== undefined;
  const isLevelOneAdmin =
    adminLevelId === 1 ||
    Number(adminUser.customerId) === 1 ||
    adminUser.UserName?.toString().toLowerCase() === "admin";
  const roleValues = [
    adminUser.Role,
    adminUser.role,
    adminUser.roleName,
    adminUser.user_role,
    adminUser.designation,
    adminUser.Designation,
    adminUser.vchDesignation,
    ...(Array.isArray(adminUser.roles) ? adminUser.roles : []),
  ];
  const isHotelManager =
    userType === "admin" &&
    !isLevelOneAdmin &&
    (hasHotelScope ||
      roleValues.some((role) =>
        String(role || "").toLowerCase().includes("manager"),
      ));

  if (isHotelManager) {
    return <RoomBlockingList />;
  }

  return (
    <div className="container-fluid admin-module-page py-4">
      <div className="admin-page-header d-flex justify-content-between align-items-start flex-wrap gap-3 mb-4">
        <div>
          <span className="admin-page-kicker">Hotel Management</span>
          <h3 className="admin-page-title fw-bold mb-1">Block History</h3>
          <p className="admin-page-description mb-0">
            View and manage room blocking records, including blocked periods, room details, and release status.
          </p>
        </div>
      </div>

      <BlockingTable />
    </div>
  )
}

export default BlockingList
